import { AnalystSeniority } from '../model/analystSeniority';
import { useUserSeniority } from '../queries/seniority';

export const useCheckIfSeniorUser = () => {
  const { data: seniority, isFetching } = useUserSeniority();
  return { isSenior: isSeniorAnalyst(seniority), isFetching };
};

export const isJuniorAnalyst = (seniority?: AnalystSeniority): boolean => {
  return seniority === AnalystSeniority.JUNIOR;
};

export const isSeniorAnalyst = (seniority?: AnalystSeniority): boolean => {
  return seniority === AnalystSeniority.SENIOR;
};
